export const testingApiHandler = {
  method: "GET",
  path: () => `auth/saml/ecornell`
};